import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0f4113b0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "feedback-container"
}
const _hoisted_2 = { class: "subtitle-2" }
const _hoisted_3 = {
  key: 1,
  class: "page-loading"
}
const _hoisted_4 = { class: "container" }
const _hoisted_5 = { class: "form-grid" }
const _hoisted_6 = { class: "form-grid" }
const _hoisted_7 = { class: "form-grid" }
const _hoisted_8 = { class: "form-grid" }
const _hoisted_9 = { class: "form-grid" }
const _hoisted_10 = {
  key: 0,
  class: "loading"
}
const _hoisted_11 = {
  key: 1,
  class: "urls"
}
const _hoisted_12 = { class: "form-grid" }
const _hoisted_13 = {
  key: 0,
  class: "form-grid"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AttensiLoadingSpinner = _resolveComponent("AttensiLoadingSpinner")!
  const _component_TheHeader = _resolveComponent("TheHeader")!
  const _component_AttensiInput = _resolveComponent("AttensiInput")!
  const _component_DropdownWrapper = _resolveComponent("DropdownWrapper")!
  const _component_AttensiButton = _resolveComponent("AttensiButton")!
  const _component_LabelLink = _resolveComponent("LabelLink")!

  return (_ctx.error)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.error.message), 1)
      ]))
    : (!_ctx.user)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_AttensiLoadingSpinner)
        ]))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          _createVNode(_component_TheHeader, {
            title: _ctx.$t('facilitator_tools.header')
          }, null, 8, ["title"]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_AttensiInput, {
                modelValue: _ctx.title,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.title) = $event)),
                label: "Leaderboard title (optional)",
                name: "title",
                placeholder: "Onboarding leaderboard 12"
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_DropdownWrapper, {
                modelValue: _ctx.product,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.product) = $event)),
                label: _ctx.$t('facilitator_tools.product_label'),
                placeholder: _ctx.$t('facilitator_tools.product_placeholder'),
                name: "product",
                options: _ctx.productOptions ?? []
              }, null, 8, ["modelValue", "label", "placeholder", "options"]),
              _createVNode(_component_DropdownWrapper, {
                modelValue: _ctx.group,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.group) = $event)),
                label: _ctx.$t('facilitator_tools.group_label'),
                placeholder: _ctx.$t('facilitator_tools.group_placeholder'),
                name: "group",
                options: _ctx.groupOptionsWithCreate ?? []
              }, null, 8, ["modelValue", "label", "placeholder", "options"]),
              _createVNode(_component_DropdownWrapper, {
                modelValue: _ctx.scenario,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.scenario) = $event)),
                label: _ctx.$t('facilitator_tools.scenario_label'),
                placeholder: _ctx.$t('facilitator_tools.scenario_placeholder'),
                name: "scenario",
                options: _ctx.scenarioOptions ?? []
              }, null, 8, ["modelValue", "label", "placeholder", "options"])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_AttensiInput, {
                modelValue: _ctx.limit,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.limit) = $event)),
                label: _ctx.$t('facilitator_tools.limit_positions_label'),
                name: "limit-positions",
                type: "number",
                placeholder: ""
              }, null, 8, ["modelValue", "label"])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_AttensiInput, {
                modelValue: _ctx.redirectUrl,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.redirectUrl) = $event)),
                label: _ctx.$t('facilitator_tools.redirect_url_label'),
                "info-text": _ctx.$t('facilitator_tools.redirect_url_info'),
                name: "redirect-url",
                placeholder: "https://portal.attensi.com/product/123456"
              }, null, 8, ["modelValue", "label", "info-text"])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_AttensiButton, {
                disabled: _ctx.isGeneratingLeaderboard,
                class: "button",
                size: "large",
                shape: "round",
                onClick: _ctx.submit
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('facilitator_tools.submit_button')), 1)
                ]),
                _: 1
              }, 8, ["disabled", "onClick"])
            ]),
            (_ctx.isGeneratingLeaderboard)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createVNode(_component_AttensiLoadingSpinner)
                ]))
              : (_ctx.urls)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createVNode(_component_LabelLink, {
                        url: _ctx.urls.leaderboardUrl,
                        label: _ctx.$t('facilitator_tools.leaderboard_url_label'),
                        "info-text": _ctx.$t('facilitator_tools.leaderboard_url_info')
                      }, null, 8, ["url", "label", "info-text"])
                    ]),
                    (_ctx.urls.inviteUrl)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                          _createVNode(_component_LabelLink, {
                            url: _ctx.urls.inviteUrl,
                            "info-text": _ctx.$t('facilitator_tools.invite_url_info'),
                            label: _ctx.$t('facilitator_tools.invite_url_label')
                          }, null, 8, ["url", "info-text", "label"])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
          ])
        ], 64))
}